module.exports = __webpack_public_path__ + "img/ic-fire.cb26f663.svg";